export default "__VITE_ASSET__CTagftuJ__"